/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentHealthInfo } from './providerComponentHealthInfo';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface ComponentHealthResponse { 
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Org Id
     */
    org_id?: string;
    vcds_service_type?: VcdsServiceTypeEnum;
    health?: ProviderComponentHealthInfo;
}
export namespace ComponentHealthResponse {
}


